import { configureStore } from '@reduxjs/toolkit';
import { i18nReducer, loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { generalApi } from './generalApi';
import { campusApi } from './campusApi';
import { getTranslations } from 'locale';

const translations = getTranslations();
const defaultLang = typeof navigator !== 'undefined' ? navigator.language : 'en-US';
const activeLocale = translations[defaultLang] ? defaultLang : 'en-US';

export const store = configureStore({
    reducer: {
        i18n: i18nReducer,
        [generalApi.reducerPath]: generalApi.reducer,
        [campusApi.reducerPath]: campusApi.reducer,
    },
    preloadedState: {
        i18n: {
            locale: activeLocale,
            translations,
        }
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredPaths: ['i18n'],
        },
        immutableCheck: {
            ignoredPaths: ['i18n'],
        }
    }).concat([
        generalApi.middleware,
        campusApi.middleware,
    ]),
});

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale(activeLocale));

export default store;
